export default "__VITE_ASSET__DuOzCDCZ__"